import { RequireAuth as SharedRequireAuth } from "@shared/components/RequireAuth";

export function RequireAuth() {
  return <SharedRequireAuth loadingClassName="mx-auto max-w-3xl px-4 py-10" />;
}
